






















































import Vue from 'vue';
import SideTabs from '@/parts/mypage/SideTabs.vue';
import ReturnTop from "@/parts/util/ReturnTop.vue";
import { notificationsLink } from '@/utils/linkUtils';
import { getUserNickName } from '@/utils/labelUtils';
import { formatDate, sortedByDateDesc } from '@/utils/momentUtils';

import { UserProfile, GetUserProfileResponse } from '@/api/dto/UserProfile';
import { getUserProfile } from '@/api/UserProfile';
import { NotificationsResponse } from '@/api/dto/Notification';
import { getNotifications, updateReadNotifications } from '@/api/Notification';
import { AnnouncementSummary } from "@/api/dto/Announcement";
import { getAnnouncements } from "@/api/Announcement";
import { defaultIconUrl } from '@/properties';

interface Data {
  /**
   * デフォルトアイコン画像
   */
  defaultIconUrl: string;
  /**
   * ユーザー情報
   */
  profileData: GetUserProfileResponse;
  /**
   * 通知（取引通知リスト）
   */
  notificationDealData: NotificationsResponse[];
    /**
   * 通知（アカウント通知リスト）
   */
  notificationAccountData: NotificationsResponse[];
  /**
   * お知らせ（新着通知）
   */
  announcementsData: AnnouncementSummary[];
  /**
   * お知らせ（新着通知）表示件数
   */
  announcementListSize: number;
}

export default Vue.extend({
  name: 'MyPage',
  components: {
    SideTabs,
    ReturnTop,
  },
  data(): Data {
    return {
      defaultIconUrl,
      profileData: {} as GetUserProfileResponse,
      notificationDealData: [],
      notificationAccountData: [],
      announcementsData: [],
      announcementListSize: 5,
    }
  },
  async beforeRouteEnter(to, from, next) {
    try {
        const userProfileRes = await getUserProfile();
        const ns = await getNotifications();
        await updateReadNotifications();
        const notifications = sortedByDateDesc(ns, it => it.date);
        const announcementsData = sortedByDateDesc(await getAnnouncements(), it => it.date);
        next(vm => {
          (vm.$data as Data).profileData = userProfileRes;
          (vm.$data as Data).notificationDealData = notifications.filter(v => v.notificationType == "1").slice(0, 10);
          (vm.$data as Data).notificationAccountData = notifications.filter(v => v.notificationType == "2").slice(0, 10);
          (vm.$data as Data).announcementsData =announcementsData;
        });
      } catch (e) {
        console.log(e);
      }
  },
  computed: {
    loginData(): UserProfile {
      return this.$store.getters.userProfile;
    },
    topAnnounce(): AnnouncementSummary[] {
      return this.announcementsData.slice(0, this.announcementListSize);
    },
    nickname(): string {
      // ログアウト時、表示名が退会済ユーザとなるのを防ぐ
      if(!this.loginData.userId) {
        return this.profileData.nickname;
      }
      return getUserNickName(this.profileData.nickname, this.loginData.userId);
    },
    userId(): string {
      // ログアウト時にユーザーIDがチラつくのを防ぐため、判定を行う
      return this.loginData.userId != "" ? this.loginData.userId : this.profileData.userId;
    }
  },
  methods: {
    notificationsLink,
    autolink(text: string){
      return text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1' target='_blank'>$1</a>")
    },
    async getAnnouncements() {
      try {
        this.announcementsData = sortedByDateDesc(await getAnnouncements(), it => it.date);
      } catch (e) {
        console.log(e);
      }
    },
    onPushPath(path: string) {
      this.$router.push(path, () => {}); // eslint-disable-line
      this.$emit('pushPath', path);
    },
  },
  filters: {
    formatDate,
  },
})
